var _path, _path2, _g, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoran(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "quran_4_",
    "data-name": "quran (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80.004,
    viewBox: "0 0 80 80.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14893",
    "data-name": "Path 14893",
    d: "M69.623,7V55.278L31,64.934v6.9l38.623,9.656V75.969L39.276,68.382,69.623,60.8l5.518-1.379V7Z",
    transform: "translate(3.481 -2.862)",
    fill: "#be8245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14894",
    "data-name": "Path 14894",
    d: "M6.518,55.278V7H1V59.416L6.518,60.8l30.346,7.587L6.518,75.969v5.518L45.14,71.831v-6.9Z",
    transform: "translate(0.379 -2.862)",
    fill: "#be8245"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6575",
    "data-name": "Group 6575",
    transform: "translate(6.897 4.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14895",
    "data-name": "Path 14895",
    d: "M38.1,16.311,5,7V55.278l31.877,8.966h2.452l31.877-8.966V7Z",
    transform: "translate(-5 -7)",
    fill: "#aa6f2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14896",
    "data-name": "Path 14896",
    d: "M5,53.138v6.9l30.346-7.587L21.553,49Z",
    transform: "translate(-5 8.934)",
    fill: "#aa6f2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14897",
    "data-name": "Path 14897",
    d: "M67.346,53.138v6.9L37,52.448,50.794,49Z",
    transform: "translate(-1.14 8.934)",
    fill: "#aa6f2a"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14898",
    "data-name": "Path 14898",
    d: "M62.346,50.519H59.335A49.278,49.278,0,0,0,32,58.8V17.414A27.879,27.879,0,0,1,55.2,5h7.15Z",
    transform: "translate(5.831 -3.621)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14899",
    "data-name": "Path 14899",
    d: "M10,50.519h3.012A49.278,49.278,0,0,1,40.346,58.8V17.414A27.879,27.879,0,0,0,17.15,5H10Z",
    transform: "translate(1.822 -3.621)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1196",
    "data-name": "Ellipse 1196",
    cx: 5.445,
    cy: 5.445,
    r: 5.445,
    transform: "translate(34.575 60.645)",
    fill: "#aa6f2a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14900",
    "data-name": "Path 14900",
    d: "M52.553,17a24.176,24.176,0,0,0-16.1,6.091,1.379,1.379,0,1,0,1.855,2.042,21.386,21.386,0,0,1,14.246-5.374,1.379,1.379,0,1,0,0-2.759Z",
    transform: "translate(7.813 0.932)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14901",
    "data-name": "Path 14901",
    d: "M52.553,23.25a26.231,26.231,0,0,0-16.031,5.579,1.38,1.38,0,1,0,1.716,2.161,23.749,23.749,0,0,1,14.315-4.981,1.379,1.379,0,1,0,0-2.759Z",
    transform: "translate(7.813 3.303)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14902",
    "data-name": "Path 14902",
    d: "M52.553,29.5c-6.042,0-12.814,2.182-16.1,5.189a1.38,1.38,0,0,0,1.862,2.037c2.785-2.547,8.908-4.467,14.242-4.467a1.379,1.379,0,0,0,0-2.759Z",
    transform: "translate(7.813 5.674)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14903",
    "data-name": "Path 14903",
    d: "M52.553,10.75a22.663,22.663,0,0,0-16.159,6.6,1.379,1.379,0,1,0,1.971,1.93,19.888,19.888,0,0,1,14.188-5.771,1.379,1.379,0,1,0,0-2.759Z",
    transform: "translate(7.813 -1.439)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14904",
    "data-name": "Path 14904",
    d: "M16.379,19.759a21.386,21.386,0,0,1,14.246,5.375,1.379,1.379,0,1,0,1.855-2.042A24.176,24.176,0,0,0,16.379,17a1.379,1.379,0,0,0,0,2.759Z",
    transform: "translate(3.255 0.932)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14905",
    "data-name": "Path 14905",
    d: "M16.379,26.009A23.749,23.749,0,0,1,30.694,30.99a1.38,1.38,0,1,0,1.716-2.161A26.231,26.231,0,0,0,16.379,23.25a1.379,1.379,0,1,0,0,2.759Z",
    transform: "translate(3.255 3.303)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14906",
    "data-name": "Path 14906",
    d: "M16.379,32.259c5.334,0,11.457,1.92,14.242,4.467a1.38,1.38,0,0,0,1.862-2.037c-3.29-3.007-10.063-5.189-16.1-5.189a1.379,1.379,0,0,0,0,2.759Z",
    transform: "translate(3.255 5.674)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14907",
    "data-name": "Path 14907",
    d: "M16.379,13.509A19.888,19.888,0,0,1,30.567,19.28a1.379,1.379,0,1,0,1.971-1.93,22.663,22.663,0,0,0-16.159-6.6,1.379,1.379,0,0,0,0,2.759Z",
    transform: "translate(3.255 -1.439)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14908",
    "data-name": "Path 14908",
    d: "M78.75,6.759h-5a1.163,1.163,0,0,0-.3.041l-4.7,1.3V5.379A1.319,1.319,0,0,0,67.5,4H61.02A25.669,25.669,0,0,0,40,15.426,25.669,25.669,0,0,0,18.979,4H12.5a1.319,1.319,0,0,0-1.25,1.379V8.1l-4.7-1.3a1.163,1.163,0,0,0-.3-.041h-5A1.319,1.319,0,0,0,0,8.138V60.554a1.361,1.361,0,0,0,.947,1.338L16.1,66.072l-10.149,2.8A1.361,1.361,0,0,0,5,70.21V82.624a1.435,1.435,0,0,0,.481,1.087,1.16,1.16,0,0,0,1.073.251l29.752-8.207a5.846,5.846,0,0,0,7.389,0l29.752,8.207a1.16,1.16,0,0,0,1.073-.251A1.435,1.435,0,0,0,75,82.624V70.21a1.361,1.361,0,0,0-.947-1.338L63.9,66.072l15.149-4.18A1.361,1.361,0,0,0,80,60.554V8.138A1.319,1.319,0,0,0,78.75,6.759ZM41.25,18.217C45.726,11.036,53.122,6.749,61.021,6.759H66.25V49.519H64.77a42.552,42.552,0,0,0-23.52,7.153Zm0,41.728a40.371,40.371,0,0,1,23.521-7.667H67.5A1.319,1.319,0,0,0,68.75,50.9V10.94L72.5,9.9V55.339L42.073,63.733a5.71,5.71,0,0,0-.823-.281ZM13.75,6.759h5.23c7.9-.009,15.294,4.277,19.771,11.459V56.673a42.551,42.551,0,0,0-23.52-7.153H13.75ZM7.5,9.9l3.75,1.035V50.9a1.319,1.319,0,0,0,1.25,1.379h2.73a40.379,40.379,0,0,1,23.529,7.673l-.008,3.5a5.709,5.709,0,0,0-.823.281L7.5,55.339Zm0,61.382,13.75-3.793L28.6,69.52,7.5,75.34Zm0,9.571V78.184l26.316-7.26A7.327,7.327,0,0,0,34.5,73.41ZM34.057,68.184l0,0L2.5,59.477V9.518H5v46.9a1.361,1.361,0,0,0,.947,1.338l29.267,8.074a7.089,7.089,0,0,0-1.157,2.355ZM40,74.348a4.158,4.158,0,0,1,0-8.276,4.158,4.158,0,0,1,0,8.276Zm32.5,6.51-27-7.449a7.327,7.327,0,0,0,.682-2.485L72.5,78.184Zm0-9.571V75.34L51.4,69.52l7.346-2.027Zm5-11.81-31.553,8.7,0,0a7.089,7.089,0,0,0-1.157-2.355l29.267-8.075A1.361,1.361,0,0,0,75,56.416V9.518h2.5Z",
    transform: "translate(0 -4)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1197",
    "data-name": "Ellipse 1197",
    cx: 1.815,
    cy: 1.815,
    r: 1.815,
    transform: "translate(38.205 64.275)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoran);
export default __webpack_public_path__ + "static/media/icon-coran.184fd174.svg";
export { ForwardRef as ReactComponent };